// @flow
import _get from 'lodash.get';

import { checkType } from 'utils/checkType';

/**
 * findAnswer the question object to return answer text.
 * @param {object} question Question Object
 * @returns {text} answer text
 */
const findAnswer = question => {
  let getAnswer = _get(question, ['childContent']);
  /* istanbul ignore else */
  if (checkType(getAnswer).isString()) {
    return getAnswer;
  }
  /* istanbul ignore else */
  if (checkType(getAnswer).isObject()) {
    getAnswer = _get(question, ['childContent', 'props', 'children']);
    /* istanbul ignore else */
    if (checkType(getAnswer).isArray()) {
      const insideArray = _get(question, [
        'childContent',
        'props',
        'children',
        [0]
      ]);

      if (checkType(insideArray).isObject()) {
        getAnswer = _get(insideArray, ['props', 'children']);

        return getAnswer;
      } else {
        return insideArray;
      }
    }

    return getAnswer;
  }
};

/**
 * Generate the FAQsSEO schema.
 * @param {object} seoSchemaObject Seo Schema Object
 * @returns {object} SEO object
 */
const generateFAQsQuestions = (seoSchemaObject: Object) => {
  const questions = seoSchemaObject.map((question, index) => {
    const answer = findAnswer(question);

    return {
      '@type': 'Question',
      name: question.accordionTitle,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer
      }
    };
  });

  return [questions];
};

/**
 * Generate the FAQsSEO schema.
 * @param {object} seoSchemaObject Seo Schema Object
 * @returns {object} SEO object
 */
const generateFAQsSeoSchema = (seoSchemaObject: Object) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: generateFAQsQuestions(seoSchemaObject)
  };

  return {
    type: 'application/ld+json',
    innerHTML: JSON.stringify(schema)
  };
};

export default generateFAQsSeoSchema;



// WEBPACK FOOTER //
// ./src/utils/seo/generateFAQsSeoSchema.js